/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_PRICE](state, { priceInString, priceInDecimal, currency }) {
    state.price.string = priceInString;
    state.price.decimal = priceInDecimal;
    state.price.currency = currency;
  },
  [types.SET_SKU](state, payload) {
    state.sku = payload;
  },
  [types.RESET_ITEMS_TO_PURCHASE](state) {
    state.itemsToPurchase = [{
      size: "",
      quantity: 1
    }];
  },
  [types.SAVE_ITEM_SIZE](state, {index, size}) {
    state.itemsToPurchase[index].size = size;
  },
  [types.SAVE_ITEM_QUANTITY](state, {index, quantity}) {
    state.itemsToPurchase[index].quantity = quantity;
  },
  [types.SET_UGC_SIZE](state, payload) {
    state.ugcSize = payload;
  },
  [types.SET_IS_UGC_APPLIED](state, payload) {
    state.isUGCApplied = payload;
  },
  [types.REPLACE_SIZE_SELECTED](state, payload) {
    state.itemsToPurchase[0].size = payload;
  },
  [types.SET_STORED_RECIPES](state, payload) {
    state.storedRecipes = payload;
  },
  [types.RESET_STORED_RECIPES](state) {
    state.storedRecipes = [];
  },
  [types.STORE_A_RECIPE](state, payload) {
    if (payload.hasOwnProperty('index')) {
      state.storedRecipes[payload.index] = payload.recipeId;
      return;
    }
    state.storedRecipes.push(payload);
  },
  [types.SAVE_REQUESTED_RECIPE](state, payload) {
    state.requestedRecipe = payload;
  },
  [types.SET_SHOW_SHARE_TO_PURCHASE](state, payload) {
    state.showShareInStore = payload;
  },
  [types.SET_CART_IMAGE](state,payload) {
    state.cartImage = payload;
  }
};

export default mutations;
